import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

var router = new VueRouter({
  mode: 'hash',
  routes
})

const validateUser = function () {
  if (localStorage.getItem('user-token')) {
    return true
  } else {
    return false
  }
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.public) {
    next()
  } else {
    const validate = await validateUser()
    if (validate) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
